import React, { useEffect,Suspense,lazy } from 'react';
import styles from './Main.module.css';
import {Container, useMediaQuery} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useLocation  } from "react-router-dom";
import {useDispatch} from 'react-redux';
import actions from './../../store/actions/index';
import Loader from '../../components/Loader/Loader';

const PreLoginView =  lazy(()=> import('./../Layouts/StandalonePages/PreLoginPage/PreLoginPage'));
const AccountView =  lazy(()=> import('./../Layouts/AccountView/AccountView'));
const RegisterPage =  lazy(()=> import('./../Layouts/StandalonePages/RegisterPage/RegisterPage'));
const SurveyResponse =  lazy(()=> import('./../Layouts/StandalonePages/SurveyResponse/SurveyResponse'));
const MaintenancePage =  lazy(()=> import('./../Layouts/StandalonePages/MaintenancePage/MaintenancePage'));
const ApplicationFooter =  lazy(()=> import('../../components/ApplicationFooter/ApplicationFooter'));
const UAMTeamInvite =  lazy(()=> import('../Layouts/StandalonePages/UAMTeamInvite/UAMTeamInvite'));
const ErrorPage =  lazy(()=> import('../Layouts/StandalonePages/ErrorPage/ErrorPage'));
const PriceListApproval =  lazy(()=> import('../Layouts/StandalonePages/PriceListApproval/PriceListApproval'));

function Main(props) {
    const { proceedTo, appCrashed, leftOverOrder, captchaEnable } = props;
    const dispatch = useDispatch();   

    const theme = useTheme();
    if (useMediaQuery(theme.breakpoints.up('md'))) {
        // desktop view
        dispatch(actions.app.setMobileView(false));
    }
    else {
        // mobile view
        dispatch(actions.app.setMobileView(true));
    }

    /* proceedTo can have these values -
        prelogin - user not authenticated, show prelogin page
        overview - user authenticated, show dashboard overview
        register - user authenticated but not yet registered in our system, show register page
        recycle - guest user, show recycle page
    */

    const location = useLocation();

    let startingComponent = null;

    if (proceedTo === "prelogin" || location.pathname === "/prelogin") {
        startingComponent = <PreLoginView />;
    }
    else if (proceedTo === "register") {
        startingComponent = <RegisterPage leftOverOrder={leftOverOrder} />;
    }
    else if (proceedTo === "survey") {
        startingComponent = <SurveyResponse />;
    }
    else if (proceedTo === "teamInvite") {
        startingComponent = <UAMTeamInvite />;
    }
    else if (proceedTo === "maintenance") {
        startingComponent = <MaintenancePage />;
    }
    else if (proceedTo === "priceApproval") {
        startingComponent = <PriceListApproval />;
    }
    else {
        startingComponent = <AccountView />;
    }

    useEffect(() => {
        if (proceedTo === "prelogin" && location.pathname === "/recycle") {
            window.location.reload();
        }
        if (proceedTo === "register" && location.pathname === "/recycle") {
            //window.location.href = removeUrlParameterByName("id");
        }
    }, [location.pathname]);

    if (appCrashed) return <ErrorPage />

    return (
        <Suspense fallback={<Loader loading={true} />}>
        <Container maxWidth={false} className={styles.MainContainer}>
            { startingComponent }
            <ApplicationFooter captchaEnable={captchaEnable} />
        </Container>
        </Suspense>
    )    
}

export default Main;